import { http } from '@/core/api/';

const apiUrl = 'api/studentreferrals';

export default {
  async getThrpyReferrals(filter) {
    let response = await http.get(`${apiUrl}/getthrpyreferrals`, {
      params: filter,
    });

    if (response.data) {
      return response.data;
    }
    return [];
  },
  async getthrpyreferraldetails(admisionid) {
    const { status, data } = await http.get(
      `${apiUrl}/getthrpyreferraldetails/${admisionid}`
    );
    if (status != 200) return [];
    return data;
  },
  async getValidDocumentTypes(studentServiceId, academicYearId) {
    let response = await http.get(`${apiUrl}/validdocumenttypes`, {
      params: {
        studentServiceId,
        academicYearId,
      },
    });
    if (response.data) {
      return response.data;
    }
    return [];
  },
  async deleteThrpyReferralItemAttachment(documentId) {
    return http.delete(
      `api/thrpyadmission/deletethrpyreferralitemattachment/${documentId}`
    );
  },
  async addCommentReferral(payload) {
    return http.post(`${apiUrl}/commentreferral`, payload);
  },
  async updateCommentReferral(id, payload) {
    return http.put(`${apiUrl}/updatecommentreferral/${id}`, payload);
  },
  async deleteCommentReferral(id) {
    return http.put(`${apiUrl}/deletecommentreferral/${id}`);
  },
  async getCommentsReferralHistory(params) {
    return http.get(`${apiUrl}/commentreferralhistory/`, { params });
  },
  async getInterventionPlan(planId, admissionId) {
    return http.get(`${apiUrl}/interventionplan/${planId}/${admissionId}`);
  },
};
